/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  current: {
    type: Number,
    "default": void 0
  },
  modelValue: {
    type: Number,
    "default": void 0
  },
  defaultCurrent: {
    type: Number,
    "default": 1
  },
  disabled: Boolean,
  foldedMaxPageBtn: {
    type: Number,
    "default": 5
  },
  maxPageBtn: {
    type: Number,
    "default": 10
  },
  pageEllipsisMode: {
    type: String,
    "default": "mid",
    validator: function validator(val) {
      if (!val) return true;
      return ["mid", "both-ends"].includes(val);
    }
  },
  pageSize: {
    type: Number,
    "default": void 0
  },
  defaultPageSize: {
    type: Number,
    "default": 10
  },
  pageSizeOptions: {
    type: Array,
    "default": function _default() {
      return [5, 10, 20, 50];
    }
  },
  selectProps: {
    type: Object
  },
  showFirstAndLastPageBtn: Boolean,
  showJumper: Boolean,
  showPageNumber: {
    type: Boolean,
    "default": true
  },
  showPageSize: {
    type: Boolean,
    "default": true
  },
  showPreviousAndNextBtn: {
    type: Boolean,
    "default": true
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium"].includes(val);
    }
  },
  theme: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "simple"].includes(val);
    }
  },
  total: {
    type: Number,
    "default": 0
  },
  totalContent: {
    type: [Boolean, Function],
    "default": true
  },
  onChange: Function,
  onCurrentChange: Function,
  onPageSizeChange: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
